export const defaultInputProps = {
    size: 'md',
};
